export default function roleService($http, RESOURCES, INSTANCE_IDS, API_V2_HEADER) {
  var service;

  service = {
    getRoles: getRoles,
  };

  function getRoles() {
    var config = {
      params: {
        instanceIds: [INSTANCE_IDS.MERCHANT_API, INSTANCE_IDS.BC_API],
      },
      headers: API_V2_HEADER.headers,
    };

    return $http.get(RESOURCES.ROLES, config);
  }
  return service;
}



// WEBPACK FOOTER //
// ./src/app/common/services/role.service.js